import CookieUtil from "../../../../lib/html5-software-library/src/ranj/util/CookieUtil";
import Config from "../../app/config/Config";
import AppModel from "../../app/core/AppModel";
import ISaveModel from "../savegame/ISaveModel";
import SaveEvent from "../savegame/SaveEvent";
import PlatformAPIEventType from "./PlatformAPIEventType";
import PlatformAPIService from "./PlatformAPIService";

export default class MockPlatformAPIService extends PlatformAPIService {
    
    /**
     * @param {AppModel} appModel 
     * @param {ISaveModel} saveModel 
     * @param {Config} config 
     */
    constructor(appModel, saveModel, config, dispatcher) {
        super(appModel, saveModel);
        this._config = config;
        this._dispatcher = dispatcher;
    }

    initialize(version) {
        this._version = version;
        this._api = {
            getConfiguration: () => {
                return {
                    language: "en",
                    launch_context: "minigame",
                    interaction_state: this._load(),
                    play_mode: "assessment"
                }
            },
            sendEvent: (eventType, payload) => {
                switch(eventType) {
                    case PlatformAPIEventType.SAVE_REQUEST:
                        this._save(payload.interaction_state);
                        break;
                }
                return true;
            },
            exit: () => {
                this._dispatcher.dispatch(SaveEvent.CLEAR);
                window.location.reload();
            }
        }
        this.getConfiguration();
    }

    _save(str) {
        window.localStorage.setItem(this._getCookieName(), str);
    }
    _load() {
        return window.localStorage.getItem(this._getCookieName());
    }
    _getCookieName() {
        return this._config.getValue(Config.APPID);
    }

}